import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { AboutSection } from '../components/AboutSection';
import { HeritageTimeline } from '../components/HeritageTimeline';
import { CoreEdge } from '../components/CoreEdge';
import { ProductLines } from '../components/ProductLines';
import { ProjectsSection } from '../components/ProjectsSection';
import { WhySolarNova } from '../components/WhySolarNova';
import { ContactSection } from '../components/ContactSection';
import { Footer } from '../components/Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <HeroSection />
      <AboutSection />
      <HeritageTimeline />
      <CoreEdge />
      <ProductLines />
      <ProjectsSection />
      <WhySolarNova />
      <div className="pb-32 bg-[#FAFAF7]">
        <ContactSection />
      </div>
      <Footer />
    </div>
  );
};

export default HomePage;
